import { render, staticRenderFns } from "./FooterStatistics.vue?vue&type=template&id=68347329&"
import script from "./FooterStatistics.vue?vue&type=script&lang=js&"
export * from "./FooterStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports